/**
 * Storage Configuration
 * Centralized storage configuration to avoid hardcoded values
 * @module @services/storage
 */

import { defaultAdapters, generateStorageKey } from '@infra/storage';
import type { StorageAdapter } from '@infra/storage';

/**
 * Storage prefix for all keys
 */
export const STORAGE_PREFIX = 'tma_sale_agents';

/**
 * Default storage adapter (can be changed per environment)
 */
export const DEFAULT_ADAPTER = defaultAdapters.local;

/**
 * Storage key names
 */
export const STORAGE_KEYS = {
  SESSIONS: 'sessions',
  AUTH_STATE: 'auth_state',
  UI_PREFS: 'ui_prefs',
  USER_PROFILE: 'user_profile',
  EMAIL_VERIFICATION_BANNER_HIDDEN: 'email_verification_banner_hidden',
} as const;

/**
 * Create storage key helper
 */
export function createStorageKey(keyName: string): string {
  return generateStorageKey(STORAGE_PREFIX, keyName);
}

/**
 * Storage domain configuration
 */
export interface StorageConfig {
  key: string;
  adapter: StorageAdapter;
}

/**
 * Create storage domain configuration
 */
export function createStorageConfig(
  keyName: string,
  adapter: StorageAdapter = DEFAULT_ADAPTER
): StorageConfig {
  return {
    key: createStorageKey(keyName),
    adapter,
  };
}
